import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Icon, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'

import { TYPE_GENERAL, TYPE_EVENT, TYPE_POLL } from 'app/constants/messageType'
import {
  PollTypeIcon,
  EventTypeIcon,
  GeneralRemiderTypeIcon,
} from 'app/components/icons'

import PrimaryTooltip from 'app/componentV4/Tooltip/PrimaryTooltip'

const useStyles = makeStyles({
  tooltip: {
    fontWeight: 400,
    fontSize: '12px',
  },
})

const MessageType = (props) => {
  const {
    type = 1,
    fill = '#A3A3A3',
    tooltip = false,
    isReminder = false,
  } = props

  const classes = useStyles()

  const renderTypeIcon = () => {
    switch (type) {
      case TYPE_GENERAL:
        return (
          <>
            {isReminder ? (
              <GeneralRemiderTypeIcon fill={fill} />
            ) : (
              <InfoOutlinedIcon style={{ color: fill }} fontSize="small" />
            )}
          </>
        )
      case TYPE_EVENT:
        return <EventTypeIcon fill={fill} />
      case TYPE_POLL:
        return <PollTypeIcon fill={fill} />
      default:
        return
    }
  }

  const renderTypeIconWithTooltip = () => {
    switch (type) {
      case TYPE_GENERAL:
        return (
          <PrimaryTooltip
            title={
              <Typography className={classes.tooltip}>
                <FormattedMessage
                  id="timeline.detail.message.type.general"
                  values={{
                    b: (text) => <b>{text}</b>,
                  }}
                />
              </Typography>
            }
          >
            {isReminder ? (
              <Icon>
                <GeneralRemiderTypeIcon fill={fill} />
              </Icon>
            ) : (
              <InfoOutlinedIcon style={{ color: fill }} fontSize="small" />
            )}
          </PrimaryTooltip>
        )
      case TYPE_EVENT:
        return (
          <PrimaryTooltip
            title={
              <Typography className={classes.tooltip}>
                <FormattedMessage
                  id="timeline.detail.message.type.event"
                  values={{
                    b: (text) => <b>{text}</b>,
                  }}
                />
              </Typography>
            }
          >
            <Icon>
              <EventTypeIcon fill={fill} />
            </Icon>
          </PrimaryTooltip>
        )
      case TYPE_POLL:
        return (
          <PrimaryTooltip
            title={
              <Typography className={classes.tooltip}>
                <FormattedMessage
                  id="timeline.detail.message.type.poll"
                  values={{
                    b: (text) => <b>{text}</b>,
                  }}
                />
              </Typography>
            }
          >
            <Icon>
              <PollTypeIcon fill={fill} />
            </Icon>
          </PrimaryTooltip>
        )
      default:
        return
    }
  }

  return <>{tooltip ? renderTypeIconWithTooltip() : renderTypeIcon()}</>
}

MessageType.propTypes = {
  type: PropTypes.number,
  fill: PropTypes.string,
  tooltip: PropTypes.bool,
  isReminder: PropTypes.bool,
}

export default MessageType
